import type { BFFArticleBodyElement } from "@src/app/types/bff";

export default function ArticleSubHead({
  element,
}: {
  element: BFFArticleBodyElement["sub_head"];
}) {
  const HeadingTag = (element.headings || "h4") as keyof JSX.IntrinsicElements;

  return (
    <HeadingTag className="text-header-4 pb-4">{element.value}</HeadingTag>
  );
}
